import { useRouter } from "solito/router";
import { LoadingButton, Paragraph2, YStack } from "@medbillai/ui";
import { homeUrl } from "@medbillai/utils/urls";
import { ScreenView } from "./ScreenView";
export const ErrorScreen = ({
  message,
  action
}: {
  message?: string;
  /** Replaces the default go-home action. */
  action?: {
    label: string;
    onPress: () => void;
  };
}) => {
  const {
    replace
  } = useRouter();
  return <ScreenView noPadding centerHorizontal widthLimit={800} stackProps={{
    "$platform-web": {
      mt: "$8"
    }
  }} data-sentry-element="ScreenView" data-sentry-component="ErrorScreen" data-sentry-source-file="ErrorScreen.tsx">
      <YStack flex={1} justifyContent="center" alignItems="center" padding="$4" data-sentry-element="YStack" data-sentry-source-file="ErrorScreen.tsx">
        <Paragraph2 bold textAlign="center" data-sentry-element="Paragraph2" data-sentry-source-file="ErrorScreen.tsx">
          {message ?? "An error occurred. Please try again later."}
        </Paragraph2>
        <LoadingButton onPress={action?.onPress ?? (() => {
        void replace(homeUrl());
      })} data-sentry-element="LoadingButton" data-sentry-source-file="ErrorScreen.tsx">
          {action?.label ?? "Go home"}
        </LoadingButton>
      </YStack>
    </ScreenView>;
};